import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IAcompanhanteQueryParams,
  IResponseAcompanhantesByAgendamento
} from './acompanhante.model';
import { buildQueryParams } from 'src/app/core/utils/builder-query-params';

@Injectable({
  providedIn: 'root'
})
export class AcompanhantesService {
  http = inject(HttpClient);
  public getAcompanhantesByAgendamento(
    params: IAcompanhanteQueryParams
  ): Observable<IResponseAcompanhantesByAgendamento> {
    const url = `${environment.baseURL}Acompanhante/GetAcompanhatesByAgendamentoId`;

    return this.http.get<IResponseAcompanhantesByAgendamento>(url, {
      params: buildQueryParams(params)
    });
  }
}
